// Copyright (c) 2016 Deere & Company

import t from 'tcomb';

const Business = t.struct({
    primaryName: t.String,
    secondaryName: t.String,
    taxId: t.String
}, {
    name: 'Business',
    strict: true
});

export const getDefaultState = () => new Business({
    primaryName: '',
    secondaryName: '',
    taxId: ''
});

export default Business;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/business.js